import { Request } from '../types';

const JSON_PATTERN = /^\{.*}$/;

export const parseEventMessage = (
  data: string | object
): Request.Event | null => {
  if (data && typeof data === 'string' && JSON_PATTERN.test(data)) {
    const message = JSON.parse(data) as Request.Event;

    if (!message.eventName) return null;

    return message;
  }

  return null;
};

export const isValidOrigin = (origin = '') => {
  const ORIGIN_PATTERN = new RegExp(
    `^https://(\\w+\\.)?${window.location.host}/?`
  );

  return ORIGIN_PATTERN.test(origin);
};
